import Table from './Table'
export * from './Table'
export * from './Table.styles.js'
export default Table
